// Dados fiscais e institucionais da Rede Hospeda.
// Fonte única da verdade para PDFs de Orçamento (backend), Recibo e Voucher (frontend).
export const FISCAL = {
  cnpj: "42.673.845/0001-98",
  razaoSocial: "Lucas Resende da Silva",
  nomeFantasia: "Rede Hospeda",
};

// Cabeçalho institucional exibido nos ORÇAMENTOS.
// Endereço institucional = sede da Rede (Pousada Central de Cabreúva).
// Telefone/e-mail = contatos oficiais compartilhados pela rede.
// `website` fica configurável: enquanto estiver vazio, a linha é omitida
// nos documentos gerados. Para publicar posteriormente, basta setar aqui
// e, se aplicável, no espelho do backend (ORC_HEADER em server.py).
export const ORCAMENTO_HEADER = {
  marca: "Rede Hospeda",
  slogan: "Gestão de Pousadas",
  cnpj: FISCAL.cnpj,
  razao_social: FISCAL.razaoSocial,
  nome_fantasia: FISCAL.nomeFantasia,
  endereco: "Rua Fernando Nunes, 872, Bairro Jacaré, Cabreúva/SP, CEP 13318-130",
  telefone: "(11) 91417-5095",
  email: "reservas@hospedacabreuva.com.br",
  website: "", // configurável — deixar vazio até termos site oficial
};
